var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container",
    style: {
      width: _vm.width < 1000 ? 1000 : _vm.width + 'px',
      height: _vm.height + 'px'
    }
  }, [_c('img', {
    staticClass: "icon1",
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230815150817.png"
    }
  }), _c('img', {
    staticClass: "icon2",
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230815151027.png"
    }
  }), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isPhoneLogin,
      expression: "!isPhoneLogin"
    }],
    staticClass: "login-erweima"
  }, [_c('div', {
    staticClass: "login-ewm-title"
  }, [_vm._v("扫码登录 微脉输入法")]), _c('div', {
    staticClass: "login-ewm-desc"
  }, [_vm._v("微脉输入法App - 设置页右上角 - 扫一扫")]), _vm._m(0), _c('div', {
    staticClass: "login-ewm-change",
    on: {
      "click": _vm.changeLoginMode
    }
  }, [_vm._v(" 手机号登录 ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPhoneLogin,
      expression: "isPhoneLogin"
    }],
    staticClass: "login-erweima"
  }, [_c('div', {
    staticClass: "login-ewm-title"
  }, [_vm._v("手机号登录")]), _c('div', {
    staticClass: "login-ewm-desc"
  }, [_vm._v("使用微脉输入法账号绑定的手机号")]), _c('div', {
    staticClass: "login-phonenum"
  }, [_c('div', {
    staticClass: "login-pn-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phoneNumber,
      expression: "phoneNumber"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": _vm.phoneNumber
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phoneNumber = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "login-pn-desc clearfix"
  }, [_c('div', [_vm._v("验证码")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phoneYanzhengma,
      expression: "phoneYanzhengma"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": _vm.phoneYanzhengma
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phoneYanzhengma = $event.target.value;
      }
    }
  })]), _c('div', {
    class: {
      huise: !_vm.yzmFlag
    },
    on: {
      "click": _vm.sendPhoneCode
    }
  }, [_vm._v(" " + _vm._s(_vm.countNum) + " ")])]), _c('div', {
    staticClass: "login-pn-code",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(" " + _vm._s(_vm.loginWord) + " ")])]), _c('div', {
    staticClass: "login-ewm-change",
    on: {
      "click": _vm.changeLoginMode
    }
  }, [_vm._v(" 二维码登录 ")])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-ewm-code"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "",
      "id": "qrcode"
    }
  })])]);
}];
export { render, staticRenderFns };